import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { emptyFunction } from '../../core/util/function';
import styled from 'styled-components';
import { LinkButton } from './Button/BaseButton';
import { colors } from '../../constants/colors';
import { fontFamily, fontSize } from '../../constants/text';

const StyledDialog = styled(Dialog)`
  border-radius: 8px;
`;

const StyledTitle = styled(DialogTitle)`
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.large};
  letter-spacing: 0.69px;
  line-height: 28px;
  color: ${colors.fadeToBlack};
`;

const StyledDescription = styled(DialogContentText)`
  color: ${colors.lightText};
`;

const StyledCtaButton = styled(LinkButton)`
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.mediumSmall};
  letter-spacing: 0.13px;
  line-height: 36px;
`;

class ErrorMessageDialog extends PureComponent {
  render() {
    const { onClose, description, title, isOpen, onClickCtaLeft, onClickCtaRight } = this.props;
    return (
      <StyledDialog
        disableAutoFocus
        open={isOpen}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <StyledTitle id="alert-dialog-title" disableTypography>
          {title}
        </StyledTitle>
        <DialogContent>
          <StyledDescription id="alert-dialog-description">{description}</StyledDescription>
        </DialogContent>
        <DialogActions>
          <StyledCtaButton onClick={onClickCtaLeft}>TRY AGAIN</StyledCtaButton>
          <StyledCtaButton onClick={onClickCtaRight}>CONTINUE</StyledCtaButton>
        </DialogActions>
      </StyledDialog>
    );
  }
}

ErrorMessageDialog.propTypes = {
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  trackEvent: PropTypes.func,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onClickCtaLeft: PropTypes.func,
  onClickCtaRight: PropTypes.func,
};

ErrorMessageDialog.defaultProps = {
  onClose: emptyFunction,
};

export default ErrorMessageDialog;
